export default "<div class=\"type-incident\">\n  {{TypeIncidentInComponent?.Designation}}\n</div>\n";